
// import React from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// const ConfirmationPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { cart, total } = location.state || {};

//   if (!cart || cart.length === 0) {
//     return (
//       <div className="max-w-3xl mx-auto py-10 px-6 text-center">
//         <h2 className="text-xl font-bold mb-4">No order found</h2>
//         <button
//           onClick={() => navigate("/")}
//           className="bg-black text-white px-6 py-2 rounded-full"
//         >
//           Return to Home
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-3xl mx-auto py-10 px-6">
//       <h1 className="text-2xl font-bold text-green-600 mb-6">
//         Thank you for your purchase!
//       </h1>
//       <p className="text-gray-700 mb-6">Here's a summary of your order:</p>

//       <div className="bg-white rounded shadow p-6 space-y-4">
//         {cart.map((item, index) => (
//           <div key={index} className="flex items-center justify-between border-b pb-4">
//             <div className="flex items-center gap-4">
//               <img
//                 src={item.images?.[0]}
//                 alt={item.name}
//                 className="w-16 h-16 object-cover rounded border"
//               />
//               <div>
//                 <p className="font-medium">{item.name}</p>
//                 <p className="text-sm text-gray-500">Size: {item.selectedSize}</p>
//               </div>
//             </div>
//             <p className="font-semibold">
//               ${(parseFloat(item.price.replace(/[^0-9.]/g, "")) * (item.quantity || 1)).toFixed(2)}
//             </p>
//           </div>
//         ))}
//         <div className="flex justify-between pt-4 font-bold text-lg">
//           <span>Total:</span>
//           <span>${total}</span>
//         </div>
//       </div>

//       <button
//         onClick={() => navigate("/")}
//         className="mt-8 w-full bg-black text-white py-3 rounded-full font-medium"
//       >
//         Continue Shopping
//       </button>
//     </div>
//   );
// };

// export default ConfirmationPage;

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cart, total } = location.state || {};

  if (!cart || cart.length === 0) {
    return (
      <div className="max-w-3xl mx-auto py-10 px-6 text-center">
        <h2 className="text-xl font-bold mb-4">No order found</h2>
        <button
          onClick={() => navigate("/")}
          className="bg-black text-white px-6 py-2 rounded-full"
        >
          Return to Home
        </button>
      </div>
    );
  }

  // Helper to find size type
  const getSizeLabel = (item) => {
    const size = item.selectedSize;
    const sizes = item.sizes;

    if (!sizes) return `Size: ${size}`;

    if (sizes.men?.includes(size)) return `US Men: ${size}`;
    if (sizes.women?.includes(size)) return `US Women: ${size}`;
    if (sizes.eu?.includes(size)) return `EU: ${size}`;

    return `Size: ${size}`;
  };

  return (
    <div className="max-w-3xl mx-auto py-10 px-6">
      <h1 className="text-2xl font-bold text-green-600 mb-6">
        Thank you for your purchase!
      </h1>
      <p className="text-gray-700 mb-6">Here's a summary of your order:</p>

      <div className="bg-white rounded shadow p-6 space-y-4">
        {cart.map((item, index) => (
          <div key={index} className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center gap-4">
              <img
                src={item.images?.[0]}
                alt={item.name}
                className="w-16 h-16 object-cover rounded border"
              />
              <div>
                <p className="font-medium">{item.name}</p>
                <p className="text-sm text-gray-500">{getSizeLabel(item)}</p>
              </div>
            </div>
            <p className="font-semibold">
              ${(parseFloat(item.price.replace(/[^0-9.]/g, "")) * (item.quantity || 1)).toFixed(2)}
            </p>
          </div>
        ))}
        <div className="flex justify-between pt-4 font-bold text-lg">
          <span>Total:</span>
          <span>${total}</span>
        </div>
      </div>

      <button
        onClick={() => navigate("/")}
        className="mt-8 w-full bg-black text-white py-3 rounded-full font-medium"
      >
        Continue Shopping
      </button>
    </div>
  );
};

export default ConfirmationPage;
